import LinePlusIcon from 'LuxKit/Icons/line/LinePlusIcon'
import Caption from 'LuxKit/Typography/Caption'
import { useIntl } from 'react-intl'
import Group from 'components/utils/Group'
import { unique } from 'lib/array/arrayUtils'
import { rem } from 'polished'
import { Fragment, useMemo } from 'react'
import styled from 'styled-components'

const Location = styled(Group)`
  column-gap: ${rem(4)};
`

interface Props {
  bundledOffers: Array<App.BundledOffer>
  showHotel?: boolean
}

export default function BundleAndSaveLocation({ bundledOffers, showHotel }: Props) {
  const intl = useIntl()
  const bundledOfferCountries = bundledOffers.map(bundledOffer => bundledOffer.locationSubheading)
  const allOffersWithinSameCountry = unique(bundledOfferCountries).length === 1

  const formatLocation = (location: string, isLast: boolean) => isLast
    ? intl.formatMessage(
        {
          id: 'jFs8t1Iew7saagvJOsY9',
          defaultMessage: '{location},',
        },
        { location },
      )
    : location

  const locations = useMemo(() => {
    if (allOffersWithinSameCountry) {
      return bundledOffers.map(bundledOffer => bundledOffer.locationHeading).filter((t): t is string => !!t)
    } else {
      return Array.from(
        new Set(bundledOffers.map(bundledOffer =>
          [bundledOffer.locationHeading, bundledOffer.locationSubheading]
            .filter(t => t)
            .join(', '))).values())
    }
  }, [allOffersWithinSameCountry, bundledOffers])

  return (
    <Location direction="horizontal" verticalAlign="center" wrap="wrap">
      {allOffersWithinSameCountry && (
        <>
          {locations.map((location, index) => (
            <Fragment key={`same-countries-${location}`}>
              {index > 0 && <LinePlusIcon colour="normal-contrast" size={12} />}
              <Caption wrap="no-wrap" variant="large" colour="normal-contrast">
                {formatLocation(location, index + 1 === locations.length)}
              </Caption>
            </Fragment>
          ))}
          <Caption variant="large" colour="normal-contrast">
            {bundledOfferCountries[0]}
          </Caption>
        </>
      )}
      {!allOffersWithinSameCountry && (
        <>
          {locations.map((location, index) => (
            <Fragment key={`different-countries-${location}`}>
              {index > 0 && <LinePlusIcon colour="normal-contrast" size={12} />}
              <Caption wrap="no-wrap" variant="large" colour="normal-contrast">
                {location}
              </Caption>
            </Fragment>
          ))}
        </>
      )}
      {showHotel && (
        <Caption variant="large" colour="light-foreground-alt" as="span">
          {intl.formatMessage({
            id: 'VBsQdYNIW0x2tPPIqrDr',
            defaultMessage: '· Hotel',
          })}
        </Caption>
      )}
    </Location>
  )
}
